import { PartTypeSchema, PartTypeType } from "../types";

export const isDiameterDimensions = (partType: PartTypeType | undefined | null): boolean => {
  if (!partType) {
    return false;
  }

  switch (partType) {
    case PartTypeSchema.enum.ROUND_TUBE:
      return true;
    case PartTypeSchema.enum.ROUND_BAR:
      return true;
    default:
      return false;
  }
};
